export const INTERIOR_STYLES = [
  { name: 'Scandy', value: 'scandy', disabled: false },
  { name: 'England', value: 'england', disabled: false },
  { name: 'Boho', value: 'boho', disabled: false },
  { name: 'Neutral', value: 'zero', disabled: false },
  { name: 'Modern', value: 'modern', disabled: false },
  { name: 'Japandi', value: 'japandi', disabled: false },
  { name: 'Elegance', value: 'elegance', disabled: false },
  { name: 'American', value: 'american', disabled: false },
  // { name: 'White Box', value: '', disabled: true },
  // { name: 'Grey shell', value: '', disabled: true },
];

export const WINDOW_VIEWS = [
  { name: 'City', value: 'city' },
  { name: 'Sandy shore', value: 'sandy' },
  { name: 'Garden', value: 'garden' },
  { name: 'Village', value: 'village' },
  { name: 'Pool', value: 'pool' },
];
